interface ProductosNode {
    translate?:string, // Auth idiomas 
    id?:string,
    name: string,
    hidden?: boolean,
    idProducto?:any,
    anio?:any,
    children?: ProductosNode[]
}
export var datosProductos: ProductosNode[] = [
    {
        translate: 'NAV.CERTIFICAR.TITULO',
        id:'certificar',
        name: 'Certificar',
        hidden: true,
        idProducto:'',
        anio:'',
        children : [
            {
                translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.0',
                id:'certify_0',
                name: 'Certificar',
                idProducto:'',
                anio:'',
                hidden: true,
            },
            {
                translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.1',
                id:'certify_1',
                name: 'Certificar',
                idProducto:'',
                anio:'',
                hidden: true,
            },
            {
                translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.2',
                id:'certify_2',
                name: 'Certificar',
                idProducto:'',
                anio:'',
                hidden: true,
            },
        ]
    },{
        translate: 'NAV.MEDIR.TITULO',
        id:'medir',
        name: 'Medir',
        hidden: true,
        idProducto:'',
        anio:'',
        children : [
            {
                translate: 'NAV.MEDIR.SUBPRODUCTOS.0',
                id:'medir_0',
                name: 'Medir standar',
                idProducto:'',
                anio:'',
                hidden: true,
            },
            {
                translate: 'NAV.MEDIR.SUBPRODUCTOS.1',
                id:'medir_1',
                name: 'Medir mejorador',
                idProducto:'',
                anio:'',
                hidden: true,
            },{
                translate: 'NAV.MEDIR.SUBPRODUCTOS.2',
                id:'medir_2',
                name: 'Medir MTS',
                idProducto:'',
                anio:'',
                hidden: true,
            },{
                translate: 'NAV.MEDIR.SUBPRODUCTOS.3',
                id:'medir_3',
                name: 'Medir áreas',
                idProducto:'',
                anio:'',
                hidden: true,
            },{
                translate: 'NAV.MEDIR.SUBPRODUCTOS.4',
                id:'medir_4',
                name: 'Medir líderes',
                idProducto:'',
                anio:'',
                hidden: true,
            },{
                translate: 'NAV.MEDIR.SUBPRODUCTOS.5',
                id:'medir_5',
                name: 'Medir Dimenciones',
                idProducto:'',
                anio:'',
                hidden: true,
            },{
                translate: 'NAV.MEDIR.SUBPRODUCTOS.6',
                id:'medir_5',
                name: 'Medir Certificar',
                idProducto:'',
                anio:'',
                hidden: true,
            },
        ]
    },{
        translate: 'NAV.PULSE.TITULO',
        id:'pulse',
        name: 'PulseCheck',
        hidden: true,
        idProducto:'',
        anio:'',
        children : []
    },{
        translate: 'NAV.FOCUS.TITULO',
        id:'focus',
        name: 'Focus Area',
        hidden: true,
        idProducto:'',
        anio:'',
        children : []
    },{
        translate: 'NAV.NORMA35.TITULO',
        id:'norma35',
        name: 'Nom035',
        hidden: true,
        idProducto:'',
        anio:'',
        children : []
    }
]



export var datosProductosCatalogo: ProductosNode[] = [
    {
        translate: 'NAV.CERTIFICAR.TITULO',
        id:'certificar',
        name: 'Certificar',
        hidden: true,
        idProducto:'',
        anio:'',
        children : []
    },{
        translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.0',
        id:'certify_0',
        name: 'Certificar',
        idProducto:'',
        anio:'',
        hidden: true,
    },{
        translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.1',
        id:'certify_1',
        name: 'Certificar',
        idProducto:'',
        anio:'',
        hidden: true,
    },{
        translate: 'NAV.CERTIFICAR.SUBPRODUCTOS.2',
        id:'certify_2',
        name: 'Certificar',
        idProducto:'',
        anio:'',
        hidden: true,
    },{
        translate: 'NAV.MEDIR.TITULO', // 4
        id:'medir',
        name: 'Medir',
        hidden: true,
        idProducto:'',
        anio:'',
        children : []
    },{
        translate: 'NAV.MEDIR.SUBPRODUCTOS.0',
        id:'medir_0',
        name: 'Medir standar',
        hidden: true,
        idProducto:'',
        anio:'',
    },
    {
        translate: 'NAV.MEDIR.SUBPRODUCTOS.1',//6
        id:'medir_1',
        name: 'Medir mejorador',
        hidden: true,
        idProducto:'',
        anio:'',
    },{
        translate: 'NAV.MEDIR.SUBPRODUCTOS.2',
        id:'medir_2',
        name: 'Medir MTS',
        hidden: true,
        idProducto:'',
        anio:'',
    },{
        translate: 'NAV.MEDIR.SUBPRODUCTOS.3',
        id:'medir_3',
        name: 'Medir áreas',
        hidden: true,
        idProducto:'',
        anio:'',
    },{
        translate: 'NAV.MEDIR.SUBPRODUCTOS.4',
        id:'medir_4',
        name: 'Medir líderes',
        hidden: true,
        idProducto:'',
        anio:'',
    },{
        translate: 'NAV.MEDIR.SUBPRODUCTOS.5',
        id:'medir_5',
        name: 'Medir Dimenciones',
        hidden: true,
        idProducto:'',
        anio:'',
    },{
        translate: 'NAV.MEDIR.SUBPRODUCTOS.6',//11
        id:'medir_5',
        name: 'Medir Certificar',
        hidden: true,
        idProducto:'',
        anio:'',
    },
    {
        translate: 'NAV.PULSE.TITULO',
        id:'pulse',
        name: 'PulseCheck',
        hidden: true,
        idProducto:'',
        anio:'',
        children : []
    },{
        translate: 'NAV.FOCUS.TITULO',
        id:'focus',
        name: 'Focus Area',
        hidden: true,
        idProducto:'',
        anio:'',
        children : []
    },{
        translate: 'NAV.FOCUS.TITULO', //14
        id:'focus',
        name: 'Focus Area',
        hidden: true,
        idProducto:'',
        anio:'',
    },{
        translate: 'NAV.NORMA35.TITULO',
        id:'norma35',
        name: 'Nom035',
        hidden: true,
        idProducto:'',
        anio:'',
        children : []
    },{
        translate: 'NAV.NORMA35.TITULO',//16
        id:'norma35',
        name: 'Nom035',
        hidden: true,
        idProducto:'',
        anio:'',
    }
]